import globalKey from '../store/globalKey'

export default {
  serverURI: globalKey,
  fixedLayout: true,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js